<template>
	<div id="app" :class="[menu ? 'twoColumns' : 'oneColumn']">
		<div id="nav" v-if="menu">
			<div class="menu-icons">
				<router-link to="/dashboard">
					<div class="menu-divider">
						<div>
							<ion-icon name="cube"></ion-icon>
						</div>
						<div>Dashboard</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/heartbeat">
					<div class="menu-divider">
						<div>
							<ion-icon name="heart"></ion-icon>
						</div>
						<div>Heartbeat</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/sync-changes">
					<div class="menu-divider">
						<div>
							<ion-icon name="sync-circle"></ion-icon>
						</div>
						<div>Sync Changes</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/top-sales">
					<div class="menu-divider">
						<div>
							<ion-icon name="bar-chart"></ion-icon>
						</div>
						<div>Top Sales</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/orders">
					<div class="menu-divider">
						<div>
							<ion-icon name="download"></ion-icon>
						</div>

						<div>Export Orders</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/order-report">
					<div class="menu-divider">
						<div>
							<ion-icon name="easel"></ion-icon>
						</div>

						<div>Order Report</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-promotions">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Export Promotions</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/members">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Export Members</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/member-rewards">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Export Member Rewards</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/search/promotions">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Search Promotions</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/check-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="checkmark-done-circle"></ion-icon>
						</div>
						<div>Check Products</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/mismatch-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="checkmark-done-circle"></ion-icon>
						</div>
						<div>Export Product Mismatch</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/shop-product-check">
					<div class="menu-divider">
						<div>
							<ion-icon name="shield-checkmark"></ion-icon>
						</div>
						<div>Shop Products Check</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="cloud-download"></ion-icon>
						</div>
						<div>Export Products</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/order-item-report">
					<div class="menu-divider">
						<div>
							<ion-icon name="download"></ion-icon>
						</div>

						<div>Order Item Reports</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/brand-price-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="code-working"></ion-icon>
						</div>
						<div>Brand Price Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/product-price-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="code-working"></ion-icon>
						</div>
						<div>Product Price Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/stock-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="options"></ion-icon>
						</div>
						<div>Stock Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/stock/sync-check">
					<div class="menu-divider">
						<div>
							<ion-icon name="options"></ion-icon>
						</div>
						<div>Stock Sync Check</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/import-shop-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="code-download"></ion-icon>
						</div>
						<div>Import Shop Products</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-popi">
					<div class="menu-divider">
						<div>
							<ion-icon name="barcode"></ion-icon>
						</div>
						<div>Export PO/PI</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-po-pdf">
					<div class="menu-divider">
						<div>
							<ion-icon name="folder"></ion-icon>
						</div>
						<div>Export PO PDF</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-return">
					<div class="menu-divider">
						<div>
							<ion-icon name="backspace"></ion-icon>
						</div>
						<div>Export Return</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/stock-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="repeat"></ion-icon>
						</div>
						<div>Export Stock Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-transfers">
					<div class="menu-divider">
						<div>
							<ion-icon name="repeat"></ion-icon>
						</div>
						<div>Export Transfers</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/warehouse-product-add">
					<div class="menu-divider">
						<div>
							<ion-icon name="repeat"></ion-icon>
						</div>
						<div>Add Warehouse Product</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-dp">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Export Direct Purchase</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/ledger">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Ledger</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/order-items/detail-report">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Items Detail Report</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/product-transfer">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Export Product Transfer</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/autoid/check">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Auto ID Check</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/delete/orders">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Delete Orders</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/delete/products">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Delete Products / Brands</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-stock-total">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Export Stock Total</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/logout">
					<div class="menu-divider">
						<div>
							<ion-icon name="log-out"></ion-icon>
						</div>
						<div>Logout</div>
					</div>
				</router-link>
			</div>

			<div>
				{{ this.$config.serverUrl }}
			</div>
		</div>

		<div class="main-content">
			<div class="menu-display-icon">
				<div @click="toggleMenu()" class="sub-menu-display-icon"><ion-icon name="apps-outline"></ion-icon></div>
			</div>
			<router-view />
		</div>
	</div>
</template>

<script>
export default {
	name: 'App',
	data: function() {
		return {
			menu: true,
			test: null
		}
	},
	watch: {
		'$store.state.route.query': {
			immidiate: true,
			handler: function(newVal) {
				this.test = newVal

				if (newVal.menu == 'false') {
					this.menu = false
					this.$store.dispatch('set_menu', false)
				} else if (newVal.menu == 'true') {
					this.menu = true
					this.$store.dispatch('set_menu', true)
				}

				if (newVal.token !== undefined && newVal.token !== '') {
					this.$axios.defaults.headers.common['Authorization'] = 'Token ' + newVal.token

					this.$store.dispatch('set_auth', newVal.token)
				} else if (this.$store.state.auth) {
					// Set auth if exist
					this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
				}
			}
		}
	},
	mounted: async function() {
		if (this.$store.state.menu === true) {
			this.menu = true
		} else {
			this.menu = false
		}
	},
	methods: {
		// Hide or display menu
		toggleMenu: function() {
			if (this.$store.state.menu === true) {
				this.menu = false
				this.$store.dispatch('set_menu', false)
			} else {
				this.menu = true
				this.$store.dispatch('set_menu', true)
			}
		}
	}
}
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/2.5.94/css/materialdesignicons.min.css');

/* Public Sans (self-hosted variable font) */
@font-face {
	font-family: 'Public Sans';
	font-style: normal;
	font-weight: 100 900;
	font-display: swap;
	src: url('./assets/fonts/public-sans-latin-ext-wght-normal.woff2') format('woff2');
	unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF,
		U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
	font-family: 'Public Sans';
	font-style: normal;
	font-weight: 100 900;
	font-display: swap;
	src: url('./assets/fonts/public-sans-latin-wght-normal.woff2') format('woff2');
	unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329,
		U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

body {
	margin: 0;
	background-color: #f3f7fd;
}

#app {
	font-family: 'Public Sans', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #11191f;
	width: 100%;
	height: 100vh;
	font-size: 14px;
}

.menu-display-icon {
	text-align: left;
}

.sub-menu-display-icon {
	width: 30px;
	color: #eee;
}

.main-content {
	background-color: #f3f7fd;
}

.twoColumns {
	display: grid;
	grid-template-columns: 200px 1fr;
}

.oneColumn {
	display: grid;
	grid-template-columns: 1fr;
}

#nav {
	background-color: #11191f;
	color: #c3cfd7;
	text-align: left;
	padding: 0 10px;
	font-size: 12px;
}

#nav .menu-icons {
	margin-top: 15px;
}

#nav .menu-divider {
	display: grid;
	grid-template-columns: 25px 1fr;
	grid-gap: 5px;
	align-items: center;
	line-height: 1.2;
}

#nav .menu-divider > div {
	display: flex;
	align-items: center;
	min-height: 22px;
}

#nav a {
	display: block;
	padding: 5px 10px;
	color: #c3cfd7;
	border-radius: 999px;
	transition: background-color 0.15s, color 0.15s;
}

#nav a:hover {
	background-color: rgba(255, 255, 255, 0.07);
	color: #fff;
}

#nav a.router-link-exact-active {
	background-color: #fff;
	color: #11191f;
	font-weight: 600;
}

#app #nav a.router-link-exact-active ion-icon {
	color: #11191f;
}

.button-wrapper {
	width: 250px;
	margin: 20px auto;
}

.big-button {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 2.3rem;
	padding: 0 1.25rem;
	background-color: #11191f;
	color: #fff;
	font-weight: 600;
	border: none;
	font-size: 13px;
	line-height: 1.2;
	border-radius: 0.75rem;
	cursor: pointer;
	outline: 0;
	transition: background-color 0.15s;
}

.small-button {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 2.3rem;
	padding: 0 1.25rem;
	background-color: #11191f;
	color: #fff;
	font-weight: 600;
	border: none;
	font-size: 13px;
	border-radius: 0.75rem;
	cursor: pointer;
	outline: 0;
}

body h1 {
	margin: 20px 0;
	font-size: 24px;
	font-weight: 700;
	color: #11191f;
	text-align: center;
}

#app input {
	box-shadow: none;
	border: 1.5px solid #cfd8de;
	border-radius: 0.75rem;
	background-color: #fff;
	color: #11191f;
	font-family: inherit;
	font-size: 13px;
	height: 40px;
	transition: border-color 0.15s, box-shadow 0.15s;
}

#app input:hover {
	border-color: #aebbc4;
}

#app input:focus {
	border-color: #11191f;
	box-shadow: 0 0 0 3px rgba(17, 25, 31, 0.1);
}

.paginationWrapper {
	margin: auto;
}

.pagination {
	height: 70px;
	width: 400px;
	margin: auto;
	padding: 5px 20px;
	font-weight: bold;
}

.pagination a {
	color: #999;
	padding: 6px 12px;
	line-height: 1.42;
}

.pagination .active a {
	color: #999;
	padding: 0;
	outline: 0;
}

.pagination li.active {
	padding: 10px;
	border-radius: 20px;
	background-color: #11191f;
	height: 40px;
	width: 40px;
}

.pagination li.active a {
	color: #fff;
	font-weight: bolder;
}

#app #nav ion-icon {
	font-size: 21px;
	color: #999;
}
/* ---- Buefy overrides: match the cloud client design ---- */
#app .title,
#app h3 {
	color: #11191f;
	font-weight: 700;
}

#app .label {
	margin-bottom: 0.4rem;
	font-size: 0.85rem;
	font-weight: 600;
	color: #11191f;
}

#app .input,
#app .textarea,
#app .select select,
#app .taginput .taginput-container.is-focusable {
	min-height: 2.6rem;
	color: #11191f;
	background-color: #fff;
	border: 1.5px solid #cfd8de;
	border-radius: 0.75rem;
	box-shadow: none;
	font-family: inherit;
}

#app .input:hover,
#app .textarea:hover,
#app .select select:hover {
	border-color: #aebbc4;
}

#app .input:focus,
#app .textarea:focus,
#app .select select:focus,
#app .input.is-focused,
#app .select select.is-focused,
#app .taginput .taginput-container.is-focusable:focus-within {
	border-color: #11191f;
	box-shadow: 0 0 0 3px rgba(17, 25, 31, 0.1);
}

#app .select:not(.is-multiple):not(.is-loading)::after {
	border-color: #11191f;
}

#app .dropdown-content,
#app .datepicker .dropdown-content {
	border-radius: 0.75rem;
	box-shadow: 0 6px 20px rgba(17, 25, 31, 0.15);
}

#app .dropdown-item.is-active,
#app .datepicker-table .datepicker-cell.is-selected,
#app .datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selected {
	background-color: #11191f;
	color: #fff;
}

#app .button {
	height: 2.3rem;
	padding: 0 1.25rem;
	font-size: 13px;
	font-family: inherit;
	font-weight: 600;
	border-radius: 0.75rem;
	box-shadow: none;
	transition: background-color 0.15s, color 0.15s;
}

#app .button.is-primary,
#app .button.is-info,
#app .button.is-link {
	color: #fff;
	background-color: #11191f;
	border-color: transparent;
}

#app .button.is-primary:hover,
#app .button.is-info:hover,
#app .button.is-link:hover,
#app .button.is-primary:focus,
#app .button.is-info:focus,
#app .button.is-link:focus {
	background-color: #2a3640;
	color: #fff;
}

#app .button.is-danger {
	border-color: transparent;
}

#app .button.is-light,
#app .button:not([class*='is-']) {
	color: #11191f;
	background-color: #fff;
	border-color: transparent;
	box-shadow: 0 1px 4px rgba(17, 25, 31, 0.12);
}

#app .button:not([class*='is-']):hover {
	color: #fff;
	background-color: #11191f;
}

#app .box,
#app .card,
#app .notification {
	border-radius: 1.25rem;
	box-shadow: 0 1px 6px rgba(17, 25, 31, 0.1);
}

#app .notification {
	box-shadow: none;
}

/* tables */
#app .table {
	background: transparent;
	color: #11191f;
}

#app .table thead th,
#app .table thead td {
	padding: 0.9rem 0.75rem;
	font-size: 0.8rem;
	font-weight: 600;
	color: #6b7a86;
	background: #fff;
	border: none;
}

#app .table tbody td {
	padding: 0.85rem 0.75rem;
	border-color: #eef1f4;
}

#app .table.is-hoverable tbody tr:hover,
#app .table tbody tr:hover {
	background-color: #f3f7fd;
}

#app .table.is-striped tbody tr:not(.is-selected):nth-child(even) {
	background-color: transparent;
}

#app .top-sold-table,
#app .top-sold-brand-table {
	background-color: #fff;
	border-radius: 0.75rem;
	color: #6b7a86;
}

/* checkboxes / radios */
#app .b-checkbox.checkbox input[type='checkbox'] + .check,
#app .b-radio.radio input[type='radio'] + .check {
	border-color: #b8c4cc;
	border-radius: 0.3em;
}

#app .b-radio.radio input[type='radio'] + .check {
	border-radius: 50%;
}

#app .b-checkbox.checkbox input[type='checkbox']:checked + .check {
	background: #11191f url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M19 6.41 17.59 5 9 13.59 5.41 10 4 11.41l5 5z'/%3E%3C/svg%3E") no-repeat center;
	border-color: #11191f;
}

#app .b-radio.radio input[type='radio']:checked + .check {
	border-color: #11191f;
	background: radial-gradient(#11191f 0, #11191f 45%, #fff 55%);
}

#app .b-radio.radio input[type='radio']:checked + .check::before {
	background: transparent;
}

/* progress bars */
#app .progress::-webkit-progress-value {
	background-color: #11191f;
}

#app .progress::-moz-progress-bar {
	background-color: #11191f;
}
</style>
